module.exports = __webpack_public_path__ + "img/profess4.a097f78b.png";